<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
  <p style="color: white">
    Loading... </p>
</ngx-spinner>

<div class="content-wrapper" style="min-height: 307px">
  <!-- แบบขอ -->
  <div class="card">
    <div class="card-header bg-primary">
      <h3 class="card-title">แบบแก้ไขข้อมูลแปลง ปี {{select_Year[3]}}</h3>
      <div class="card-tools">
        <!--<button type="button" class="btn btn-tool" (click)="ngOnInit();"><i class="fas fa-sync"></i></button>-->
        <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i> </button>
        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-7">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" *ngIf="listYear.length>0">
                <mat-label>1.เลือกปี</mat-label>
                <mat-select required [(ngModel)]="select_Year" (ngModelChange)="goloadfarmerinzone()">
                  <mat-option *ngFor="let item of listYear; let i = index;" [value]="item">
                    ปี - {{item[4]}} -
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-8">
              <mat-form-field appearance="outline" *ngIf="famerlist2.length>0">
                <mat-label>2.เลือกชาวไร่</mat-label>
                <mat-select required [(ngModel)]="farmer" (ngModelChange)="LoadOnefarmerdata()">
                  <mat-form-field class="example-form-field" appearance="outline">
                    <mat-label>ค้นหา -*เลือกชาวไร่*-</mat-label>
                    <input matInput type="text" [(ngModel)]="txtFindIn" focus (ngModelChange)="search_dataFM()">
                    <button *ngIf="txtFindIn" matSuffix mat-icon-button aria-label="Clear"
                      (click)="txtFindIn=''"><mat-icon>close</mat-icon></button>
                  </mat-form-field>
                  <mat-option *ngFor="let item of famerlist1; let i = index;" [value]="item">
                    {{i+1}}.[{{ item.fmcode_b1 }}]-{{ item.fmname }}, {{ item.cnt }} แปลง,
                    โซน-{{ item.SUPZONE }}
                  </mat-option>
                  <mat-option *ngIf="famerlist1.length==0" [value]="" disabled>.--ไม่พบข้อมูล--.</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="table-responsive" style="height: 400px">
            <table class="table table-sm table-head-fixed">
              <thead>
                <tr class="headText text-primary" style="text-align:center">
                  <th scope="col">เลขแปลง</th>
                  <th scope="col">โซน</th>
                  <th scope="col">นสส</th>
                  <th scope="col">ประเภท</th>
                  <th scope="col">พื้นที่</th>
                  <th scope="col">ตัน/ไร่</th>
                  <th scope="col">สถานะสินเชื่อ</th>
                  <th scope="col">กรรมสิทธิ์</th>
                  <th scope="col">เลือก</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of dataonefarmer" style="text-align:center">
                  <td>{{item.intlandno}}</td>
                  <td>{{item.supzone}}</td>
                  <td>{{item.supcode}}</td>
                  <td>{{item.CaneTypeName}}</td>
                  <td>{{item.landvalue | number:'1.2-2' }}</td>
                  <td>{{item.Ton | number:'1.0-1' }}</td>
                  <td>{{item.CaneTypeName}}</td>
                  <td>{{item.plotdesc}}</td>
                  <td>
                    <button class="btn btn-success btn-sm" (click)="Getselectdata(item);">
                      <i class="fa fa-arrow-circle-right"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-5" *ngIf="oneselect.length>0">
          <!--<div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="inputGroupSelect01">เลือกหัวข้อ</label>
              </div>
              <select class="custom-select" id="inputGroupSelect01" formControlName="title" (change)="SwapForm()">
                <option selected disabled>กรุณาเลือก...</option>
                <option *ngFor="let item of asktitle" [ngValue]="item.edit_type">{{item.edit_type_name}}</option>

              </select>
            </div>-->

          <mat-form-field appearance="outline">
            <mat-label>เลือกหัวข้อแก้ไข</mat-label>
            <mat-select required [(ngModel)]="edit_type" (ngModelChange)="SwapForm()">
              <mat-option *ngFor="let item of asktitle;" [value]="item.edit_type">
                {{item.edit_type_name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="row">
            <div class="col-md-6">
              <table>
                <thead *ngFor="let item of oneselect">
                  <tr> เจ้าของแปลง : <label>{{item.fmname}}</label> </tr>
                  <tr> โควตาเจ้าของ : <label>{{item.fmcode}}</label> </tr>
                  <tr> หมายเลขแปลง : <label>{{item.intlandno}}</label> </tr>
                  <tr> พื้นที่ : <label>{{item.landvalue|number:'1.2-2'}}</label> ไร่ , ประเภทอ้อย :
                    <label>{{item.CaneTypeName}}</label>
                  </tr>
                  <tr> ประเมิน : <label>{{item.Ton}}</label> ตัน/ไร่ , ปริมาณตัน : <label>{{item.Assess}} </label> ตัน
                  </tr>
                  <tr> กรรมสิทธิ์ : <label>{{item.plotdesc}}</label> , โซน : <label>{{item.supzone}}</label> </tr>
                  <tr> นักส่งเสริม : <label>{{item.supcode}} | {{item.supname}}</label> </tr>
                </thead>
              </table>
            </div>
            <div class="col-md-6 ">
              <br>
              <table class="table table-sm table-bordered" *ngIf="data_factors.length>0">
                <thead>
                  <tr style="text-align:center">
                    <th scope="col">ประเภท</th>
                    <th scope="col">จำนวนคำขอ </th>
                    <th scope="col">จำนวนเงิน</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of data_factors" style="text-align:center">
                    <td>{{item.doc_name}}</td>
                    <td>{{item.count_doc}}</td>
                    <td>{{item.money_amt|number}}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="text-align:center">
                    <td>รวม</td>
                    <td></td>
                    <td>ฺ<b>{{sum_money_amt|number}}</b></td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <hr>
            <p *ngIf="edit_type >0"> ค่าเดิม : <b>{{old_value}}</b></p>
            <!-- ยกเลิกแปลง -->
            <table class="example-full-width" cellspacing="0">
              <tr>
                <div class="input-group input-group-sm mb-3" *ngIf="edit_type == 1">
                  <div class="input-group-prepend">
                    <label class="input-group-text" for="inputGroupSelect01">ยกเลิกแปลง </label>
                  </div>
                </div>
                <!-- ยกเลิกแปลง -->

                <!-- แก้ไขประเภทอ้อย -->
                <mat-form-field appearance="fill" *ngIf="edit_type == 2">
                  <mat-label>แก้ไขประเภทอ้อย</mat-label>
                  <mat-select [(ngModel)]="edit_be" (ngModelChange)="not_give = true">
                    <mat-option *ngFor="let item of canetype" [value]="[item.code,item.name]">
                      {{item.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- แก้ไขประเภทอ้อย -->

                <!-- แก้ไขเจ้าของแปลง -->
                <!--<div class="input-group input-group-sm mb-3" *ngIf="edit_type == 3">
                    <span class="input-group-text">แก้ไขเจ้าของแปลง</span>
                    <span class="input-group-text">เจ้าของแปลงเดิม</span>
                    <input type="text" class="form-control" formControlName="threeonwer_plantold">
                    </div>-->
                <!--<div class="input-group input-group-sm mb-3" *ngIf="edit_type == 3">
                    <span class="input-group-text">เจ้าของแปลงใหม่</span>
                    <input type="text" class="form-control" formControlName="threeonwer_plantnewcode"
                      placeholder="โควตาเจ้าของแปลงใหม่" maxlength="10"
                      onkeypress='return event.charCode >= 48 && event.charCode <= 57' (change)="LoadFmdataFromCode();">
                    <input type="text" class="form-control" formControlName="threeonwer_plantnew" disabled>
                    </div>-->
                <table style="width: 100%;" *ngIf="edit_type == 3">
                  <tr style="text-align:center;">
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-label>โควตาเจ้าของใหม่ (10ตัว)</mat-label>
                        <input matInput [(ngModel)]="fmcode_f" placeholder="ใส่เลขโควตา"
                          onkeypress='return event.charCode >= 48 && event.charCode <= 57' name="fmcode_f"
                          maxlength="12" value="">
                      </mat-form-field>
                    </td>
                    <td>
                      <button mat-stroked-button color="primary" (click)="searchFm()"
                        [disabled]="fmcode_f.length!<10">ตกลง</button>
                    </td>
                  </tr>
                  <tr>
                    <label>เจ้าของใหม่: {{new_fm.code}}-{{new_fm.fName}}</label>
                  </tr>
                </table>

                <!-- แก้ไขเจ้าของแปลง -->

                <!-- แก้ไขนักโซน -->
                <!--<div class="input-group input-group-sm mb-3" *ngIf="edit_type == 4">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="inputGroupSelect01">แก้ไขโซน = </label>
                      <select class="custom-select" id="inputGroupSelect01" formControlName="fourzone">
                        <option selected disabled>กรุณาเลือก...</option>
                        <option *ngFor="let li of zonecode" [ngValue]="[li.SUPZONE,li.ZONENAME]">{{li.SUPZONE}} |
                          {{li.ZONENAME}}</option>
                      </select>
                    </div>
                    </div>-->
                <mat-form-field appearance="fill" *ngIf="edit_type == 4">
                  <mat-label>แก้ไขโซน</mat-label>
                  <mat-select [(ngModel)]="edit_be" (ngModelChange)="not_give = true">
                    <mat-option *ngFor="let li of zonecode" [value]="[li.SUPZONE,li.SUPZONE]">
                      {{li.SUPZONE}} | {{li.ZONENAME}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- แก้ไขนักโซน -->

                <!-- แก้ไขนักส่งเสริม ผู้ดูแลแปลง -->
                <mat-form-field appearance="fill" *ngIf="edit_type == 6">
                  <mat-label>นักส่งเสริม|ผู้ดูแลแปลง</mat-label>
                  <mat-select [(ngModel)]="edit_be" (ngModelChange)="not_give = true">
                    <mat-option *ngFor="let sv of supportlist" [value]="[sv.code,sv.fName]">
                      {{sv.code}}|{{sv.fName}} - โซน {{sv.ZoneId}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- แก้ไขนักส่งเสริม ผู้ดูแลแปลง -->

                <!-- แก้ไขกรรมสิทธิ์แปลง  -->
                <mat-form-field appearance="fill" *ngIf="edit_type == 5">
                  <mat-label>แก้ไขกรรมสิทธิ์แปลง</mat-label>
                  <mat-select [(ngModel)]="edit_be" (ngModelChange)="not_give = true">
                    <mat-option [value]="[1,'ตนเอง']"> ตนเอง </mat-option>
                    <mat-option [value]="[2,'เช่า']"> เช่า </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- แก้ไขกรรมสิทธิ์แปลง  -->

              </tr>
              <tr>
                <mat-form-field class="example-full-width" appearance="fill" *ngIf="edit_type >0">
                  <mat-label>หมายเหตุ</mat-label>
                  <textarea matInput [(ngModel)]="edit_data.comment" placeholder="Ex. It makes me feel..."></textarea>
                </mat-form-field>
              </tr>
              <tr>
                <td>
                  <section>
                    <mat-checkbox color="warn" [(ngModel)]="confirm_d" [disabled]="edit_type==0||!not_give">
                      ยืนยันข้อมูลถูกต้อง
                    </mat-checkbox>
                  </section>
                  <section>
                    <button [disabled]="!confirm_d" mat-raised-button color="primary"
                      (click)="SendAsk()">บันทึกข้อมูล</button>
                  </section>
                </td>
                <td>
                  <mat-label>{{edit_be|json}}</mat-label>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /.card-body -->
  </div>
  <!-- แบบขอ -->

  <!-- รายการที่ร้องขอ -->
  <div class="card">
    <div class="card-header bg-Indigo">
      <h3 class="card-title">รายการคำขอที่ส่งเรื่อง</h3>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="LoadlistAsk();"><i class="fas fa-sync"></i></button>
        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
        </button>
      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <table class="table table-sm">
        <thead>
          <th scope="col">เลขที่คำขอ</th>
          <th scope="col">วันที่ </th>
          <th scope="col">หมายเลขแปลง </th>
          <th scope="col">เรื่องที่ขอ</th>
          <th scope="col">สถานะ</th>
          <th scope="col">ความเห็นสินเชื่อ</th>
          <th scope="col">หมายเหตุ</th>
          <th scope="col">ยกเลิกคำขอ</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of zonelist">
            <td>{{item.edit_ID}}</td>
            <td>{{item.date_add|date}}</td>
            <td>{{item.intlandno}}</td>
            <td>{{item.edit_type_name}} | {{item.edit_from}} > {{item.edit_to}}</td>
            <td>{{item.edit_status_doc}}</td>
            <td>{{item.comment3}}</td>
            <td>{{item.comment}}</td>
            <td>
              <button class="btn btn-danger btn-sm" (click)="CancleEdit(item.edit_ID);">
                ยกเลิก
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- /.card-body -->
  </div>
</div>
<app-footer></app-footer>